module.exports = __webpack_public_path__ + "15_pvis.png?3c5cf6c3eba379030026bb218eae4bec";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/15_pvis.png
// module id = 157
// module chunks = 0